export enum ConsentActivityType {
  OPT_IN = 100000000,
}

export class ConsentActivity {
  public indskr_consentactivityid: string;
  public indskr_consentactivitytitle: string;
  public consentTermId: string;
  public consentTermName: string;
  public contactId?: string;
  public indskr_consentactivitytype: number;
  public createdon: string;
  public createdby: string;
  public indskr_consentTypeName?: string;
  public indskr_consenttypeid?: string;
  public indskr_emailaddress?: string;
  public indskr_product?: string;
  public indskr_productname?: string;
  public indskr_phone?: string;
  public indskr_faxnumber?: string;
  public indskr_addressname?: string;
  public indskr_consentactivitysourcetype?: string;
  public indskr_optinsource?: string;
  public indskr_topic?: string;
  public indskr_topic_Formatted?: string;
  public indskr_consentid?: string;

  constructor(raw: object) {
    this.indskr_consentactivityid = raw['indskr_consentactivityid'] || '';
    this.indskr_consentactivitytitle = raw['indskr_consentactivitytitle'] || '';
    this.consentTermId = raw['indskr_consenttypeid'] || '';
    this.consentTermName = raw['indskr_consentTypeName'] || '';
    this.contactId = raw['contactId'] || '';
    this.indskr_consentactivitytype = raw['indskr_consentactivitytype'] || ConsentActivityType.OPT_IN;
    this.createdon = raw['indskr_consentactivitycreatedon'] || '';
    this.createdby = raw['_createdby_value'] || '';
    this.indskr_consentTypeName = raw['_indskr_consenttype_value_Formatted'] ? raw['_indskr_consenttype_value_Formatted'] : raw['indskr_consentTypeName'] ? raw['indskr_consentTypeName'] : '';
    this.indskr_consenttypeid = raw['_indskr_consenttype_value'] ? raw['_indskr_consenttype_value'] : raw['indskr_consenttypeid'] ? raw['indskr_consenttypeid'] : '';
    this.indskr_emailaddress = raw['emailAddress'] ? raw['emailAddress'] : raw['indskr_emailaddress'] ? raw['indskr_emailaddress'] : '';
    this.indskr_product = raw['indskr_product']
    this.indskr_productname = raw['indskr_productname'] || '';
    this.indskr_phone = raw['indskr_phone'] || '';
    this.indskr_faxnumber = raw['indskr_faxnumber'] || '';
    this.indskr_addressname = raw['indskr_addressname'] || '';
    this.indskr_consentactivitysourcetype = raw['indskr_consentactivitysourcetype'] || '';
    this.indskr_optinsource = raw['indskr_optinsource'] || '';
    this.indskr_topic = raw['topic'] || '';
    this.indskr_topic_Formatted = raw['topicName'] || '';
    this.indskr_consentid = raw['indskr_consentid'];
  }
}